import createClient from '../../helpers/api-client';

const storeSuffix = 'Authentication';

//Actions
export const LOG_IN = `logInAction${storeSuffix}`;
export const LOG_OUT = `logOutAction${storeSuffix}`;
export const AUTHENTICATE = `authenticateAction${storeSuffix}`;

//Mutations
export const BEGIN_AUTHENTICATION = `beginAuthenticationMutation${storeSuffix}`;
export const SET_AUTHENTICATION_TOKEN = `setAuthenticationTokenMutation${storeSuffix}`;
export const USER_NOT_FOUND = `userNotFoundMutaion${storeSuffix}`;
export const RECEIVE_USER_INFORMATION = `receiveUserInformationMutation${storeSuffix}`;
export const LOGIN_RESET = `loginResetAction${storeSuffix}`;

//Getters
export const GET_USER = `getUserGetters${storeSuffix}`;
export const GET_ERROR = `getErrorGetters${storeSuffix}`;
export const IS_AUTHENTICATED = `ìsAuthenticatedGetters${storeSuffix}`;
export const IS_LOADING = `isLoadingGetters${storeSuffix}`;
export const IS_CUSTOMER = `isCustomerGetter${storeSuffix}`;
export const IS_COMPANY = `isCompanyGetter${storeSuffix}`;

//state
export const modelState = () => ({
    authentication: {
        isLoading: true,
        authenticated: false,
        error: false,
        authenticationToken: false,
        user: {},
        isCustomer: false,
        isCompany: false,
    },
});

export const actions = {
    [LOG_IN]: ({ state, commit }, logInData) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state, {});
            commit(BEGIN_AUTHENTICATION);

            try {
                const loginRes = await apiClient.post(`/api/login`, logInData);
                if (
                    loginRes.data.role === 'Client' ||
                    loginRes.data.role === 'Contractor'
                ) {
                    const user = {
                        userName: loginRes.data.userName,
                        name: loginRes.data.name,
                        signature: loginRes.data.signature,
                        userId: loginRes.data.userId,
                    };

                    if (loginRes.data.role == 'Contractor') {
                        user.role = 'Company';
                    } else if (loginRes.data.role == 'Client') {
                        user.role = 'Customer';
                    }

                    const token = loginRes.data.access_token;
                    const expires = loginRes.data.expires_in;

                    if (process.title === 'browser') {
                        window.$cookies.set(
                            'authentication_token',
                            token,
                            expires,
                            '/'
                        );
                        window.$cookies.set('userData', user, expires, '/');
                    }

                    commit(SET_AUTHENTICATION_TOKEN, {
                        authenticationToken: token,
                    });
                    commit(RECEIVE_USER_INFORMATION, user);

                    resolve(user);
                } else {
                    const error = 'Användaren har inte tillgång';
                    commit(USER_NOT_FOUND, { error });
                }
            } catch (error) {

                if(error.message && JSON.parse(error.message).error == "invalid_grant" && JSON.parse(error.message).error_description == "2") {
                    error = 'Hej! Du kan tyvärr inte logga in för din användare eller företag inte är aktiv(t) eller saknar en aktiv tjänst. Vänligen kontakta oss för hjälp.';
                } else {
                    error = 'Något gick fel. Kontrollera att dina uppgifter är korrekta.';
                }
                commit(USER_NOT_FOUND, { error });
                reject(error);
            }
        });
    },
    [LOG_OUT]: ({ state, commit }) => {
        return new Promise(async resolve => {
            const authenticated = state.authentication.authenticated;

            if (process.title === 'browser' && authenticated) {
                window.$cookies.remove('authentication_token');
                window.$cookies.remove('userData');
            }

            commit(LOGIN_RESET);
            return resolve();
        });
    },
    [AUTHENTICATE]: ({ state, commit }, userData) => {
        return new Promise(async (resolve, reject) => {
            const authToken = state.authentication.authenticationToken;

            if (!authToken) {
                commit(LOGIN_RESET);
                return resolve();
            }

            commit(BEGIN_AUTHENTICATION);

            if (userData && Object.keys(userData).length > 0) {
                commit(RECEIVE_USER_INFORMATION, userData);
                resolve(userData);
            } else {
                commit(USER_NOT_FOUND, { error: 'User not found' });
                reject(new Error('User not found'));
            }
        });
    },
};

export const mutations = {
    [SET_AUTHENTICATION_TOKEN]: (state, payload) => {
        state.authentication.authenticationToken = payload.authenticationToken;
    },
    [BEGIN_AUTHENTICATION]: state => {
        state.authentication.authenticated = false;
        state.authentication.isLoading = true;
        state.authentication.user = {};
        state.authentication.error = false;
    },
    [RECEIVE_USER_INFORMATION]: (state, payload) => {
        state.authentication.isLoading = false;
        state.authentication.authenticated = true;
        state.authentication.user = payload;
        state.authentication.error = false;
    },
    [USER_NOT_FOUND]: (state, { error }) => {
        state.authentication.isLoading = false;
        state.authentication.authenticated = false;
        state.authentication.user = {};
        state.authentication.error = error;
    },
    [LOGIN_RESET]: state => {
        state.authentication.isLoading = false;
        state.authentication.authenticated = false;
        state.authentication.user = {};
        state.authentication.error = false;
    },
};

export const getters = {
    [GET_USER]: state => {
        const user = state.authentication.user;

        if (typeof user === 'string') {
            return JSON.parse(user);
        }
        return user;
    },
    [IS_CUSTOMER]: state => {
        const user = state.authentication.user;
        let isCustomer = state.authentication.isCustomer;
        let parsedUser = typeof user === 'string' ? JSON.parse(user) : '';

        if (parsedUser.role === 'Customer' || user.role === 'Customer') {
            return (isCustomer = true);
        }
        return (isCustomer = false);
    },
    [IS_COMPANY]: state => {
        const user = state.authentication.user;
        let isCompany = state.authentication.isCompany;
        let parsedUser = typeof user === 'string' ? JSON.parse(user) : '';

        if (parsedUser.role === 'Company' || user.role === 'Company') {
            return (isCompany = true);
        }

        return (isCompany = false);
    },
    [IS_LOADING]: state => {
        return state.authentication.isLoading;
    },
    [IS_AUTHENTICATED]: state => {
        return state.authentication.authenticated;
    },
    [GET_ERROR]: state => {
        return state.authentication.error;
    },
};



// WEBPACK FOOTER //
// ./src/store/store-models/authentication-model.js